export class AddPbaTransactionPayload {
  transactionId: number;
}
